// extracted by mini-css-extract-plugin
module.exports = {"rootAbsolute":"Tags_rootAbsolute__nM8wq","tag":"Tags_tag__1ftag","statusCourse":"Tags_statusCourse__1Vu7N"};